import type { datadogLogs } from '@datadog/browser-logs'

// Ref: https://nuxt.com/docs/getting-started/error-handling#vue-errors
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (error) => {
    if (error instanceof HttpError) {
      (nuxtApp.$datadogLogs as typeof datadogLogs).logger.error(`Global HTTP Error: ${error.message}`, error, error)
    }
    else if (error instanceof Error) {
      (nuxtApp.$datadogLogs as typeof datadogLogs).logger.error(`Global Unexpected Error: ${error.message}`, error, error)
    }
  })
})
